const ENTRADAS_COMPRA = (state, entradas_compra) => {
    state.entradas_compra = entradas_compra;
};

export default {
    ENTRADAS_COMPRA,
};